<template>
  <component
    :is="componentType"
    dense
    outlined
    hide-details
    single-line
    :return-object="false"
    :value="value"
    :items="items"
    :label="label"
    :clearable="clearable"
    :prepend-inner-icon="icon"
    :data-testid="dataTestid"
    :disabled="disabled"
    :loading="loading"
    :search-input.sync="searchInput"
    @input="value => $emit('input', value)"
    @keydown.enter="closeMenuAfterConfirmation"
    ref="input"
  />
</template>

<script>
export default {
  name: 'autocomplete-text-field',
  props: {
    value: {
      type: String,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    clearable: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
    allowNewValues: {
      type: Boolean,
      default: false,
    },
    ariaLabel: {
      type: String,
      default: null,
    },
    disabled: Boolean,
    dataTestid: String,
    loading: Boolean,
  },
  data() {
    return {
      searchInput: null,
    };
  },
  computed: {
    componentType() {
      return this.allowNewValues ? 'v-combobox' : 'v-autocomplete';
    },
    isDirty() {
      // allowNewValues時のみ、未確定の入力（searchInputとvalueの不一致）を検知する
      if (!this.allowNewValues) return false;
      if (this.searchInput === null) return false;
      return this.searchInput !== this.value;
    },
  },
  watch: {
    isDirty(val) {
      this.$emit('update:dirty', val);
    },
    searchInput() {
      // タイプ直後はハイライトをクリアし、Enter押下で常に入力値が新規確定されるようにする
      // (デフォルトではフィルタ後の最初の項目がハイライトされ、Enterで強制選択されてしまう)
      this.$nextTick(() => {
        const { input } = this.$refs;
        if (input == null || typeof input.setMenuIndex !== 'function') return;
        input.setMenuIndex(-1);
      });
    },
  },
  methods: {
    closeMenuAfterConfirmation(event) {
      // IME入力中は処理しない
      if (event.isComposing) return;
      // Enter後にフォーカスを外す。
      // v-combobox 標準動作では Enter 確定時に isSearching が false になり、
      // フィルタが解除されて全件表示に戻ってしまうため、blur で対処する。
      // setTimeout(0) は v-combobox の Enter 内部処理 (microtask) 完了を
      // 待つため。同期や $nextTick だと値確定処理と競合する。
      setTimeout(() => {
        const { input } = this.$refs;
        if (input == null) return;
        input.blur();
      }, 0);
    },
  },
  mounted() {
    this.$refs.input.$refs.input.setAttribute('aria-label', this.ariaLabel);
  },
};
</script>
